import { render } from "./ModalInput.vue?vue&type=template&id=3fdc1d92&ts=true"
import script from "./ModalInput.vue?vue&type=script&lang=ts"
export * from "./ModalInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__